import { UcoastEl } from '@/scripts/core/UcoastEl'
import {
	getAttributeOrThrow,
	getAttributeOrUndefined, getDistanceFromDocumentTop,
	qsRequired,
} from '@/scripts/core/global'

export class ProductStickyCta extends UcoastEl {
	static htmlSelector = 'product-sticky-cta'
	uniqueId: string
	anchor: HTMLElement
	anchorPosition: number
	visible: boolean
	startingHeight: number
	footerAnchor: HTMLElement
	footerAnchorPosition: number
	constructor() {
		super()
		const initScrollTop =
			window.pageYOffset || document.documentElement.scrollTop
		this.uniqueId = getAttributeOrThrow('data-unique-id', this)
		this.anchor = qsRequired(`[data-sticky-cta-anchor="${this.uniqueId}"]`)
		this.anchorPosition = getDistanceFromDocumentTop(
			this.anchor,
			initScrollTop
		)
		this.footerAnchor = qsRequired('.shopify-section-group-footer-group')
		this.footerAnchorPosition =
			getDistanceFromDocumentTop(this.footerAnchor, initScrollTop) -
			this.footerAnchor.scrollHeight * 2
		this.visible = this.isVisible()
		this.startingHeight = this.getBoundingClientRect().height
	}
	isVisible() {
		return getAttributeOrUndefined('data-visible', this) === 'true'
	}
	show() {
		if (this.isVisible()) return
		this.setAttribute('data-visible', 'true')
	}
	hide() {
		if (!this.isVisible()) return
		this.setAttribute('data-visible', 'false')
	}
	onHeaderScrollEvent(scrollTop: number, headerCurrentScrollTop: number) {
		this.processScroll(scrollTop, headerCurrentScrollTop)
	}
	processScroll(scrollTop: number, headerCurrentScrollTop: number) {

		const difference = Math.abs(scrollTop - headerCurrentScrollTop)
		const topVal = scrollTop + this.startingHeight * 3

		if (scrollTop < headerCurrentScrollTop &&
			difference > 1 && window.Ucoast.screen.width < 990) {
			requestAnimationFrame(this.hide.bind(this))
			return
		}

		if (!qsRequired('body').classList.contains('shopify-section-header-hidden') && window.Ucoast.screen.width < 990) {
			requestAnimationFrame(this.hide.bind(this))
			return
		}

		if (scrollTop >= this.footerAnchorPosition) {
			this.hide()
			return
		}
		if (topVal >= this.anchorPosition) {
			this.show()
			return
		}
		this.hide()
	}
}
